import { FIELD_KEYS } from './field-keys';

export const NON_IMPACT_FIELDS = new Set([
	FIELD_KEYS.INVOICE_REFERENCE,
	FIELD_KEYS.PICKUP_REFERENCE,
	FIELD_KEYS.DROP_REFERENCE,
	FIELD_KEYS.PUBLISH_UNTIL,
	FIELD_KEYS.PUBLISH,
]);

export const NON_IMPACT_FIELDS_QUOTE = new Set([
	...NON_IMPACT_FIELDS,
	FIELD_KEYS.PRICE,
	FIELD_KEYS.ACCEPTANCE_PRICE,
]);

export const isImpactKey = (k?: string) => !!k && !NON_IMPACT_FIELDS.has(k);
export const isQuoteImpactKey = (k?: string) =>
	!!k && !NON_IMPACT_FIELDS_QUOTE.has(k);
